/** Пресеты качества live-видео (control WS → FFmpeg). */

export type VideoQualityId = 'high' | 'medium' | 'low'

export type VideoQualityOptions = {
  stream: 'main' | 'sub'
  /** FFmpeg scale WxH; null = только выравнивание под mpeg1 */
  scale: string | null
  /** mpeg1 q:v (меньше = лучше) */
  q: number
}

export type VideoQualityPreset = {
  id: VideoQualityId
  label: string
  title: string
  options: VideoQualityOptions
}

export const VIDEO_QUALITY_PRESETS: VideoQualityPreset[] = [
  {
    id: 'high',
    label: 'Выс',
    title: 'Высокое',
    options: { stream: 'main', scale: null, q: 5 },
  },
  {
    id: 'medium',
    label: 'Ср',
    title: 'Среднее 1280×720',
    options: { stream: 'main', scale: '1280:720', q: 5 },
  },
  {
    id: 'low',
    label: 'Экон',
    title: 'Эконом 640×352',
    options: { stream: 'sub', scale: '640:352', q: 8 },
  },
]

const STORAGE_KEY = 'kitsupport.trassir.liveQuality'

export function getVideoQualityPreset(id: VideoQualityId): VideoQualityPreset {
  return VIDEO_QUALITY_PRESETS.find((p) => p.id === id) || VIDEO_QUALITY_PRESETS[0]
}

export function readStoredVideoQuality(): VideoQualityId {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw === 'high' || raw === 'medium' || raw === 'low') return raw
  } catch {
    /* ignore */
  }
  return 'high'
}

export function saveStoredVideoQuality(id: VideoQualityId) {
  try {
    localStorage.setItem(STORAGE_KEY, id)
  } catch {
    /* ignore */
  }
}
